import React, { useContext } from "react";
import { Result, Button, ConfigProvider } from "antd";
import { AuthContext } from "../services/authcontext";

const NotFoundPage = () => {
  const { user } = useContext(AuthContext);

  const getHomePath = () => {
    const isAdmin = user?.roles?.some((role) => role.name === "ROLE_ADMIN");
    return isAdmin ? "/Users" : "/";
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#D97A07",
        },
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "60vh",
        }}
      >
        <Result
          status="404"
          title={
            <span style={{ color: "var(--text-main, #0D2E4D)" }}>404</span>
          }
          subTitle={
            <span style={{ color: "var(--text-muted, #657487)" }}>
              Sorry, the page you visited does not exist.
            </span>
          }
          extra={
            <Button
              type="primary"
              size="large"
              href={getHomePath()}
              style={{
                backgroundColor: "#D97A07",
                borderColor: "#D97A07",
                fontWeight: "600",
                padding: "0 40px",
              }}
            >
              Back Home
            </Button>
          }
        />
      </div>
    </ConfigProvider>
  );
};

export default NotFoundPage;
